import debounce from 'lodash.debounce';
import smoothscroll from 'smoothscroll-polyfill';
import { isDown } from '../utils/mediaQuery';

export default class AboutUs {
  constructor() {
    this.aboutUs = document.querySelector('main.about-us');
    this.yearSelectors = document.querySelectorAll('.about-us .timeline .year-select');
    this.yearDropdowns = document.querySelectorAll('.about-us .timeline .drop-down');
    this.yearDropdownOptions = document.querySelectorAll('.about-us .timeline .drop-down li');

    if (this.aboutUs) {
      this.aboutUs.addEventListener('click', this.hideAllYearDropdown.bind(this));
      this.yearSelectors.forEach((button) => {
        button.addEventListener('click', this.displayYearDropdown.bind(this));
      });
      this.yearDropdownOptions.forEach((el) => {
        el.addEventListener('click', this.jumpToSection.bind(this));
      });
      window.addEventListener(
        'resize',
        debounce(() => {
          this.repositionDropdown();
        }, 400)
      );

      smoothscroll.polyfill();
      this.repositionDropdown();
    }
  }

  repositionDropdown() {
    this.yearDropdowns.forEach((el) => {
      const index = el.dataset.index;

      if (isDown('sm')) {
        el.style.top = `${361 - 42 * index}px`;
      } else if (isDown('lg')) {
        el.style.top = `${461 - 46 * index}px`;
      } else {
        el.style.top = `${40 - 43 * index}px`;
      }
    });
  }

  displayYearDropdown(e) {
    e.stopPropagation();

    let parent = e.target;
    while (!parent.classList.contains('year-select')) {
      parent = parent.parentElement;
    }

    const dropdownEl = parent.nextElementSibling;
    dropdownEl.classList.add('show');
  }

  hideAllYearDropdown(e) {
    this.yearDropdowns.forEach((el) => {
      el.classList.remove('show');
    });
  }

  jumpToSection(e) {
    const target = e.target.dataset.jumpto;
    let elementY = window.pageYOffset + document.getElementById(target).getBoundingClientRect().top;

    // Add offset if there is global banner
    let offset = 0;
    const globalBanner = document.querySelector('body .banner');

    if (globalBanner) {
      if (isDown('lg')) {
        offset = 64;
      } else {
        offset = 58;
      }
    }

    // Add another offset if scrolling up for the nav
    let isScrollUp = elementY < window.pageYOffset;

    if (isScrollUp) {
      if (isDown('sm')) {
        offset += 54;
      } else if (isDown('lg')) {
        offset += 72;
      } else {
        offset += 82;
      }
    }

    elementY -= offset;

    window.scroll({ top: elementY, behavior: 'smooth' });
  }
}
